import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { URL } from "../../api";
import axiosInstance from "../../Request";

import {
  Card,
  CardHeader,
  CardBody,
  Form,
  Row,
  Col,
} from "reactstrap";

import "react-datepicker/dist/react-datepicker.css";

import privilegeList from "../../PrivilegeList";
import CustomerDetailsForm from "./CustomerDetails";
import ProfessionalDetails from "./ProfessionalDetails";
import CurrentAddress from "./CurrentAddress";
import PermanentAddress from "./PermanentAddress";
import ReferenceDetails from "./ReferenceDetails";
import NomineeDetails from "./NomineeDetails";
import OfficeAddress from "./OfficeAddress";

const Index = () => {
  const { cid, lid } = useParams();
  const [startDate, setStartDate] = useState(new Date());
  const [customerDetails, setCustomerDetails] = useState(null);
  const [leadStatus, setLeadStatus] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const [disableEdit, setDisableEdit] = useState(false);


  useEffect(() => {
  const fetchCustomerDetails = async () => {
    try {
      const response = await axiosInstance.get(
        `${URL.CUSTOMER_DETAILS}?customer_id=${cid}&lead_id=${lid}`
      );
      const data = response.data;
      setCustomerDetails(data);

      const leadStatus = data?.leadStatus;
      setLeadStatus(leadStatus);

      if (leadStatus === 25 || leadStatus === 26 || leadStatus === 28 || leadStatus === 27) {
        setDisableEdit(true);
      } else {
        setDisableEdit(false);
      }
      setLeadStatus(data?.leadStatus);

    } catch (error) {
      console.error("Error fetching customer details:", error);
    }
  };
  

    fetchCustomerDetails();
  }, [cid, lid]);

  

  const [states, setStates] = useState([]);
const [citiesMap, setCitiesMap] = useState({});

useEffect(() => {
  fetchStates();
}, []);

const fetchStates = async () => {
  try {
    const res = await axiosInstance.get(URL.GET_STATES);
    const entries = Object.entries(res.data); // { stateName: id }
    const formatted = entries.map(([name, id]) => ({ name, id }));
    setStates(formatted);
  } catch (err) {
    console.error("Failed to load states", err);
  }
};

const fetchCities = async (stateName) => {
  const selected = states.find((s) => s.name === stateName);
  if (!selected || citiesMap[selected.id]) return;

  try {
    const res = await axiosInstance.get(`${URL.GET_CITIES}?stateCode=${selected.id}`);
    const entries = Object.entries(res.data);
    const formatted = entries.map(([name, id]) => ({ name, id }));
    setCitiesMap((prev) => ({ ...prev, [selected.id]: formatted }));
  } catch (err) {
    console.error("Failed to load cities", err);
  }
};

  return (
    <>
      <Card className="bg-secondary shadow">
        <CardHeader className="bg-white border-0">
          <Row className="align-items-center">
            <Col xs="8">
              <h3 className="mb-0">Customer Info</h3>
            </Col>
          </Row>
        </CardHeader>
          <CardBody>
            <Form>
              <CustomerDetailsForm
                customerDetails={customerDetails}
                startDate={startDate}
                setStartDate={setStartDate}
                isEditable={isEditable}
                setIsEditable={setIsEditable}
                privilegeList={privilegeList}
                disableEdit={disableEdit}
              />
                  <>
                <h3 className="mb-3">Addresses</h3>
                <Row>
                    <Col className="md= 6" >
                      <CurrentAddress
                          customerDetails={customerDetails}
                          privilegeList={privilegeList}
                          states={states}
                          fetchCities={fetchCities}
                          citiesMap={citiesMap}
                          disableEdit={disableEdit}
                      />
                    </Col>
                    <Col className="md= 6">
                      <PermanentAddress
                        customerDetails={
                          leadStatus === 26 && customerDetails?.currentAddress
                            ? { ...customerDetails, permanentAddress: customerDetails.currentAddress }
                            : customerDetails
                        }
                        privilegeList={privilegeList}
                        states={states}
                        fetchCities={fetchCities}
                        citiesMap={citiesMap}
                        disableEdit={disableEdit}
                      />
                    </Col>                   
                </Row>
                </>
              <ProfessionalDetails
                customerDetails={customerDetails}
                privilegeList={privilegeList}
                disableEdit={disableEdit}
              />
              {/* Office / Reference / Nominee are not applicable to payment-flow customers
                  (leadStatus 26) — hide them so the view isn't full of -NA- sections. */}
              {leadStatus !== 26 && (
                <>
                  <OfficeAddress
                    customerDetails={customerDetails}
                    privilegeList={privilegeList}
                    states={states}
                    fetchCities={fetchCities}
                    citiesMap={citiesMap}
                    disableEdit={disableEdit}
                  />
                  <ReferenceDetails
                    customerDetails={customerDetails}
                    privilegeList={privilegeList}
                    disableEdit={disableEdit}
                  />
                  <NomineeDetails
                    customerDetails={customerDetails}
                    privilegeList={privilegeList}
                    disableEdit={disableEdit}
                  />
                </>
              )}
            </Form>
          </CardBody>
      </Card>
    </>
  );
};

export default Index;
